(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.student.name)
    .factory('graduationPlanReqNameSvc', ['$http', '$q', function ($http, $q) {            

            var getGradPlanReqNames = function (keycode) {
                console.info('In getGradPlanReqNames service');
                console.info('Making a call to service');
                var categories = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.student.endpoints.getGradPlanRequirementNamesEndpoint,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    categories = response.data;
                    deferred.resolve(categories);
                    console.info('Got the additional requirements names');
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getPartPrograms = function(keycode,userSchools){
                console.info('In getPartPrograms service');
                console.info('Making a call to service');
                var userSchoolIds = _.pluck(userSchools, 'schoolId');
                var partPrograms = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.student.endpoints.getPartProgramsEndpoint,
                    params: {
                                schoolIds: userSchoolIds.toString()
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function(response){
                    partPrograms = response.data;
                    deferred.resolve(partPrograms);
                    console.info('Got the participant programs');
                }, function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getCurrentCtePrograms = function(keycode,userSchools){
                console.info('In getCurrentCtePrograms service');
                console.info('Making a call to service');
                var userSchoolIds = _.pluck(userSchools, 'schoolId');
                var ctePrograms = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.student.endpoints.getCteProgramsEndpoint + '/current',
                    params: {
                                schoolIds: userSchoolIds.toString()
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function(response){
                    ctePrograms = response.data;
                    deferred.resolve(ctePrograms);
                    console.info('Got the current cteprograms');
                }, function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getFutureCtePrograms = function(keycode,userSchools){
                console.info('In getFutureCtePrograms service');
                console.info('Making a call to service');
                var userSchoolIds = _.pluck(userSchools, 'schoolId');
                var cteFuturePrograms = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.student.endpoints.getCteProgramsEndpoint + '/future',
                    params: {
                                schoolIds: userSchoolIds.toString()
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function(response){
                    cteFuturePrograms = response.data;
                    deferred.resolve(cteFuturePrograms);
                    console.info('Got the future cteprograms');
                }, function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            var getRetroChangeIndicator = function(keycode,studentId,studentGradPlanId,schoolId,isSave,dateTime){
                console.info("Retro Change Indicator");
                var indicator;
                var deferred = $q.defer();
                var request =  $http({
                url: schoolwork12.app.student.endpoints.studentEdit + studentId + '/retro/gradplan/' + studentGradPlanId+ '/schoolId/'+ schoolId ,  
                method : "GET",
                headers : {
                            'X-API-TOKEN': keycode
                        },
                params: {
                            isSave : isSave,
                            dateTime : dateTime
                        }
                });
                request.then(function(response){
                    indicator = response.data;
                    deferred.resolve(indicator);
                    console.info('Got the indicator');
                }, function(error){
                    deferred.reject(error);
                });
                return deferred.promise;
            };

            const getPostHS = function (keycode) {
                var postHS = null;
                var deferred = $q.defer();
                var request = $http({
                    method: 'GET',
                    url: schoolwork12.app.student.endpoints.getPostHS,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-TOKEN': keycode
                    }
                });
                request.then(function (response) {
                    postHS = response.data;
                    deferred.resolve(postHS);
                }, function (error) {  
                    deferred.reject(error);
                });
                return deferred.promise;
            };

        
            return {                
                getGradPlanReqNames: getGradPlanReqNames,  
                getPartPrograms: getPartPrograms,
                getCurrentCtePrograms: getCurrentCtePrograms,
                getFutureCtePrograms: getFutureCtePrograms,
                getRetroChangeIndicator: getRetroChangeIndicator,
                getPostHS              
            };
        }

    ]);
}(angular, schoolwork12));